module.exports = "<div class=\"loader\"></div>"